import React, { useCallback, useState, useMemo, useEffect } from "react";
import JoditEditor from "jodit-react";
import "../style.css";
import useSanitizedContent from "@egovernments/digit-ui-module-common/src/hooks/useSanitizedContent";

export default function DemoParinted({ content, setContent, useNewSanitized = false }) {
  const [logs, setLogs] = useState([]);
  const appendLog = useCallback(
    (message) => {
      const newLogs = [...logs, message];
      setLogs(newLogs);
    },
    [logs, setLogs]
  );

  const config = useMemo(
    () => ({
      readonly: false,
      height: 300,
      cleanHTML: {
        cleanOnPaste: true,
        removeEmptyElements: true,
      },
      allowTags: "p,strong,em,a,ul,ol,li,br,img",
      allowAttributes: ["href", "src", "alt"],
      defaultLinkProtocol: "https",
      removeEmptyAttributes: true,
      disablePlugins: ["about"],
    }),
    []
  );

  const onChange = useCallback((newContent) => appendLog(`onChange triggered: ${newContent}`), [appendLog]);

  const onBlur = useSanitizedContent(setContent, appendLog, useNewSanitized);

  useEffect(() => {
    // console.log("onChange = ", onChange);
  }, [onChange]);

  return (
    <div>
      <JoditEditor value={content} config={config} tabIndex={1} onBlur={onBlur} onChange={onChange} />
    </div>
  );
}
